export default __webpack_public_path__ + "static/media/TuscanChicken.41ddb1b9.jpg";